import {IdAndName} from "types/GenericTypes";
import {AddOrEditVoyageData} from "views/ProcessDetails/refactor/components/ProcessBoarding/components/Voyages/AddOrEditVoyageModal/AddOrEditVoyageModal";
import {
  Voyage,
  VoyageToSend,
} from "views/ProcessDetails/refactor/types/voyages.types";
import {
  ID_COLLECT_VOYAGE,
  ID_INITIAL_VOYAGE,
} from "views/ProcessDetails/utils/constants";

/**
 *   Viagem de coleta tem origem null e destino obrigatorio
 * emb. inicial e transbordo tem origem e destino obrigatorios
 * destino final tem origem e destino obrigatorios (destino deve ser um type OUTROS, não aeroporto)
 * entrega tem origem obrigatoria e destino opcional
 */
export const calculateInitialValues = (
  voyages: Voyage[],
): {origin?: IdAndName | null; destination?: IdAndName | null} => {
  const allVoyages = voyages;

  const lastValidVoyage = allVoyages.findLast(
    (voyage) => voyage.typeVoyage?.id !== ID_COLLECT_VOYAGE,
  );

  const initialVoyage = voyages.find(
    (voyage) => voyage.typeVoyage?.id === ID_INITIAL_VOYAGE,
  );

  return {
    origin: lastValidVoyage?.destination,
    destination: initialVoyage?.origin,
  };
};

export const mapVoyageDataToSend = (
  dataToSend: any,
  receivedData: AddOrEditVoyageData,
): Partial<VoyageToSend> => {
  return {
    id: dataToSend?.id ?? receivedData?.id,
    idTypeVoyage: dataToSend?.typeVoyage?.id,
    idOrigin: dataToSend?.origin?.id,
    idDestination: dataToSend?.destination?.id,
    idVessel: dataToSend?.vessel?.id,
    voyageFlight: dataToSend?.voyageFlight,
    estimatedCargoLoad: dataToSend?.estimatedCargoLoad,
    cargoLoad: dataToSend?.cargoLoad,
    estimatedCargoUnload: dataToSend?.estimatedCargoUnload,
    cargoUnload: dataToSend?.cargoUnload,
    placePickup: dataToSend?.placePickup,
    placeDelivery: dataToSend?.placeDelivery,
    typeService: dataToSend?.typeService,
    grantDate: dataToSend?.grantDate,
    bindingDate: dataToSend?.bindingDate,
    idTransportCompany: dataToSend?.transportCompany?.person?.id,
    observation: dataToSend.observation,
  };
};
